import React, { useRef, useState } from 'react';
import { authHeaders } from '../../utils/api';
import { useAvatarUrl, setAvatar } from '../../utils/avatars';
import { getAvatarColor } from '../../utils/avatar';
import { getDisplayName } from '../../utils/admin';
import { toast } from '../Toast';
import { AvatarCropper } from './AvatarCropper';

// 계정 설정 > 프로필: 사진 고르기 → 확대·위치 조정 후 자르기 → 적용
export function ProfilePhotoTab({ clientData }) {
    const current = useAvatarUrl(clientData.userId);
    const [file, setFile] = useState(null); // 자르는 중인 원본 사진
    const [busy, setBusy] = useState(false);
    const inputRef = useRef(null);
    const name = getDisplayName(clientData.username);

    const pick = (e) => {
        const picked = e.target.files?.[0];
        e.target.value = '';
        if (!picked) return;
        if (!picked.type.startsWith('image/')) return toast.error('사진 파일을 선택해 주세요.');
        if (picked.size > 30 * 1024 * 1024) return toast.error('사진이 너무 큽니다. (최대 30MB)');
        setFile(picked);
    };

    const upload = async (blob) => {
        setBusy(true);
        try {
            const form = new FormData();
            form.append('avatar', blob, blob.type === 'image/webp' ? 'avatar.webp' : 'avatar.jpg');
            const res = await fetch('/api/me/avatar', { method: 'POST', headers: authHeaders(), body: form });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || !data.ok) throw new Error(data.message || '저장하지 못했습니다.');
            setAvatar(clientData.userId, data.avatar);
            setFile(null);
            toast.success('프로필 사진을 바꿨습니다.');
        } catch (err) { toast.error(err.message); }
        finally { setBusy(false); }
    };

    const remove = async () => {
        setBusy(true);
        try {
            const res = await fetch('/api/me/avatar', { method: 'DELETE', headers: authHeaders() });
            if (!res.ok) throw new Error('삭제하지 못했습니다.');
            setAvatar(clientData.userId, null);
            toast.success('프로필 사진을 삭제했습니다.');
        } catch (err) { toast.error(err.message); }
        finally { setBusy(false); }
    };

    return (
        <div className="profile-tab">
            <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/*" hidden onChange={pick} />
            {file ? (
                <AvatarCropper file={file} busy={busy} onCancel={() => setFile(null)} onConfirm={upload} />
            ) : (
                <>
                    <div className="profile-preview" style={current ? undefined : { backgroundColor: getAvatarColor(clientData.userId) }}>
                        {current ? <img src={current} alt="현재 프로필 사진" /> : name.substring(0, 1).toUpperCase()}
                    </div>
                    <div className="profile-name">{name}</div>
                    <p className="profile-hint">채팅·접속자 목록에 표시됩니다. 올린 뒤 확대·위치를 조정할 수 있어요.</p>
                    <div className="profile-actions">
                        <button className="profile-btn primary" onClick={() => inputRef.current?.click()} disabled={busy}>{current ? '사진 바꾸기' : '사진 올리기'}</button>
                        {current && <button className="profile-btn danger" onClick={remove} disabled={busy}>사진 삭제</button>}
                    </div>
                </>
            )}
        </div>
    );
}
